export default function SellInInvoiceVsImeiScanCountTableHeaderView() {

  function renderTableHeader(tableData) {

    const { monthsNormalized, monthsASC, weeksASC } = tableData;

    const monthThTags = [m("th", { colspan: 2, rowspan: 2 }, "SCAN%")];
    const weekThTags = [];

    for (let month of monthsASC) {
      const weeksOfMonth = Object.keys(monthsNormalized[month]);
      monthThTags.push(m("th", { colspan: weeksOfMonth.length + 1 }, month));
    }

    for (let { week } of weeksASC) {
      weekThTags.push(m("th", week));
    }

    monthThTags.push(m("th", { colspan: 2, rowspan: 2 }, "Total"));

    return m("thead.thead-bggrey",
      m("tr.text-center.align-middle", monthThTags),
      m("tr.text-center.align-middle", weekThTags),
    )
  }

  return {
    view: (vnode) => {
      return renderTableHeader(vnode.attrs.tableData)
    }
  }
}